import { render, staticRenderFns } from "./WithTaskBadges.vue?vue&type=template&id=143ece9c&scoped=true"
import script from "./WithTaskBadges.vue?vue&type=script&lang=js"
export * from "./WithTaskBadges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143ece9c",
  null
  
)

export default component.exports